import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { API } from "../App";

const initial = () => {
  const seo = window.__SEO__;
  if (!seo) return null;
  return seo.canonical && new URL(seo.canonical).pathname !== window.location.pathname ? null : seo;
};

// Head tags come from the same backend resolver that server-renders each page, so both always match.
export const RouteSEO = () => {
  const { pathname, search } = useLocation();
  const [meta, setMeta] = useState(initial);

  useEffect(() => {
    if (meta && window.__SEO__ === meta) {
      window.__SEO__ = null;
      return;
    }
    let live = true;
    axios.get(`${API}/seo/meta`, { params: { path: pathname + search } })
      .then((r) => live && setMeta(r.data))
      .catch(() => {});
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);

  if (!meta) return null;
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="robots" content={meta.robots} />
      {meta.canonical && <link rel="canonical" href={meta.canonical} />}
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content={meta.og_type} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Videography Cape Town" />
      <meta property="og:locale" content="en_ZA" />
      {meta.canonical && <meta property="og:url" content={meta.canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />
      {meta.jsonld.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
};
